export default {
    payBy3d: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/onlinesales/state.js